<script>
import productCardMixin from '@/v-shop/mixins/product-card-mixin'

export default {
	lang: 'shop',
	mixins: [productCardMixin],

	hooksKey: 'ProductCard',
	provide() {
		return {
			hookContainer: () => this,
		}
	},
}
</script>

<template>
	<div class="h100" :class="{ 'center-card-sq-wrapper': $b.d, 'product-card-sq-wrapper-mobile': $b.mt }">
		<v-hover v-slot="{ hover }">
			<v-card
				@mouseover="firstImageHover = true"
				:hover="!outOfStock ? true : false"
				outlined
				@click="cardClick"
				:ripple="false"
				:class="$bem('center-card-sq')"
				class="h100 d-flex flex-column overflow-hidden justify-space-between base product-card"
			>
				<div :class="$bem('__image-cont mx-2')" v-if="!outOfStock">
					<hook zone="image">
						<Media
							cover
							:class="$bem('__main-image')"
							:src="mainImage"
							width="100%"
							aspect-ratio="1.5"
							imgClass="center-card-sq__image--smallWidth"
						/>
						<div v-if="secondImage && firstImageHover" :class="$bem('__second-image-cont')">
							<Media
								cover
								:src="secondImage"
								width="100%"
								aspect-ratio="1.5"
								:class="[$bem('__second-image'), hover ? $bem('__second-image--show') : '']"
								imgClass="center-card-sq__image--smallWidth"
							/>
						</div>
					</hook>
				</div>

				<div :class="$bem('__image-cont mx-2', 'no-stock')" v-else>
					<hook zone="image">
						<Media
							:class="$bem('__main-image')"
							:src="mainImage"
							width="100%"
							aspect-ratio="1.5"
							imgClass="center-card-sq__image--smallWidth"
						/>
					</hook>
				</div>

				<hook zone="price" :class="{ 'no-stock': outOfStock }">
					<PriceText
						:amount="price"
						:currency="currency"
						:class="[$bem('__price'), { 'product-card-sq__price-mobile': $b.mt }]"
						class="price font-2 font-weight-bold line-clamp-1 mt-1 px-2"
						priceClass="text-center"
					/>
				</hook>

				<div
					class="d-flex align-center px-2 justify-center"
					v-if="prevPrice"
					:class="[
						$bem('__prev-price'),
						{ 'no-stock': outOfStock },
						{ 'product-card-sq__prev-prices-mobile': $b.mt },
					]"
				>
					<hook zone="prevPrice">
						<del class="grey--text">
							<PriceText
								:amount="prevPrice"
								:currency="currency"
								:currencyMargin="0"
								:class="{ 'product-card-sq__prev-price-mobile': $b.mt }"
								priceClass="grey--text font-0"
							/>
						</del>
					</hook>

					<hook zone="discount">
						<span
							v-if="discountPct > 0"
							:class="[$bem('__discount'), { 'product-card-sq__discount-mobile': $b.mt }]"
							class="d-inline-block discount font-0 ml-2"
						>
							{{ discountPct }}% OFF
						</span>
					</hook>
				</div>

				<v-spacer :class="{ 'center-card-sq__spacer--flex-grow': !discountPct }" />

				<router-link class="card-anchor header" :to="productRoute">
					<hook zone="name" :class="{ 'no-stock': outOfStock }">
						<div
							:class="[$bem('__name'), { 'product-card-sq__name-mobile': $b.mt }]"
							class="line-clamp-2 header mb-2 px-2 font-weight-regular font-1 text-center"
						>
							{{ product.name }}
						</div>
					</hook>
				</router-link>

				<CollectionEventIcon
					:product="product"
					:class="[
						$bem('__event-icon'),
						{ 'no-stock': outOfStock },
						{ 'product-card-sq__event-icon-mobile': $b.mt },
					]"
					imgWidth="25px"
				/>
			</v-card>
		</v-hover>
	</div>
</template>

<style lang="scss" scoped>
.center-card-sq-wrapper {
	height: 240px;
	width: 224px;
}

.center-card-sq {
	position: relative;
	cursor: pointer;
	border: 1px solid #eaeaea;
	text-align: center;

	&__image-cont {
		position: relative;
	}

	&__second-image-cont {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	&__second-image {
		transition: opacity 0.3s;
		opacity: 0;
		&--show {
			opacity: 1;
		}
	}

	&__spacer--flex-grow {
		flex-grow: 0.75 !important;
	}

	&__event-icon {
		position: absolute;
		top: 50%;
		right: 8px;
		z-index: 1;
		width: 25px;
	}

	&__discount {
		padding: 2px 5px;
		border-radius: 4px;
	}
}

::v-deep .center-card-sq__image--smallWidth {
	max-width: 110px;
	max-height: 180px;
	left: 50% !important;
	translate: -50%;
}

.no-stock {
	opacity: 0.4;
}

a.card-anchor:before {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	z-index: 2;
	left: 0;
}
</style>
